import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@treatwell/ui';
import styles from './ShowMore.module.css';

export const ShowMore = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation();

  return (
    <Button className={styles.showMoreButton} onClick={onClick}>
      {t('browsePage.filter.seeMoreOptions')}
    </Button>
  );
};
